import { AuthResponce } from './../../features/autorization/authorization.types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuth: boolean;
}

const initialState: AuthState = {
  isAuth: !!localStorage.getItem('banditto'),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logIn: (state, action: PayloadAction<AuthResponce>) => {
      state.isAuth = true;
      localStorage.setItem('banditto', JSON.stringify(action.payload));
    },
    logOut: (state) => {
      state.isAuth = false;
      localStorage.removeItem('banditto');
    },
  },
});

export default authSlice.reducer;
export const { logIn, logOut } = authSlice.actions;
